<template>
  <b-modal
    title="Crear tipo de vehículo"
    v-model="show"
    size="xl"
    no-close-on-backdrop
    scrollable
  >
    <b-row>
      <b-col>
        <div class="form-group">
          <label>Descripción</label>
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="form.descripcion"
            placeholder="Descripción"
          />
        </div>
      </b-col>
    </b-row>
    <template #modal-footer>
      <div class="form-group">
        <button class="btn btn-sm btn-circle" @click="() => (show = false)">
          <i class="la la-reply"></i> Cancelar
        </button>
        <button class="btn btn-sm btn-success" @click="createVehicleType()">
          <i class="la la-save"></i> {{ loading ? "Cargando..." : "Guardar" }}
        </button>
      </div>
    </template>
  </b-modal>
</template>
<script>
import axios from "axios";
import toastr from "toastr";
export default {
  data() {
    return {
      show: false,
      loading: false,
      form: {
        descripcion: null,
      },
    };
  },
  methods: {
    init() {
      this.show = true;
      this.form = {
        descripcion: null,
      };
    },
    createVehicleType() {
      if (this.form.descripcion) {
        axios
          .post(`/vehiculo-tipos`, { data: [this.form] })
          .then((res) => {
            if (res.data.message == "success") {
              toastr.success(res.data.information);
              this.$emit("loadVehiclesType", true);
              this.show = false;
            } else {
              toastr.info(res.data.information);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        if (!this.form.descripcion) {
          toastr.info(`El campo descripción es obligatorio`);
        }
      }
    },
  },
};
</script>
